export default "__VITE_ASSET__DKcoHW43__"